import { render, staticRenderFns } from "./qs1-20.vue?vue&type=template&id=783ee04c&scoped=true&"
import script from "./qs1-20.vue?vue&type=script&lang=js&"
export * from "./qs1-20.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783ee04c",
  null
  
)

export default component.exports